import * as React from "react";
import * as moment from "moment";
import * as _ from "lodash";
import * as qs from "qs";
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { Dispatch, connect } from "react-redux";
import { Modal, ModalHeader, ModalTitle, ModalFooter, Button, Row, Col, FormControl, ControlLabel, Alert, DropdownButton, MenuItem } from "react-bootstrap";
import { toast } from "react-toastify";
import { IApplicationState, SwapActionCreators, IRccapPositionDetailResponse, AppActionCreators, IMatchingCallsResponse } from "@nkr/store/index";
import { ICluster, IContact, IListItem, IRccapRootCause, IRccapPositionDetailRequest, IBaseResponse, IRccapAdditionalQuestionWithValidation } from "@nkr/models/index";
import { ICancelSwap, IResponsibleCenter } from "../../../models";
import { IActionPosition, actionTypeList, IActionType, ActionTypes } from "./models";
import { RccapStatus, ClusterStatus, EmailStatusType, PreSelectReversalResponsible } from "@nkr/enums/index";
import { ActionsRowWrapper, ModalBodyWrapper } from "./styles";
import { IStrongBoxUsageContract } from '@nkr/models/strong-box/strong-box-usage';
import RccapDetail from "./rccap-detail";
import SwapList from "./swap-list";
import RccapSwapList from "./rccap-swap-list";
import DateTimePicker from "@nkr/components/date-time-picker";

import "@nkr/services/extensions";

enum ImmediteEmailType {
    CommenceXm = 1,
    ScheduleLogistics = 2,
    ScheduleKickoff = 3,
    CancelSwap
}

interface IServiceResponse {
    data: {
        IsSuccess: boolean,
        IsValidationError: boolean,
        Details: any,
        ErrorMessages: any[]
    }
}

interface IOwnProps {
    show: boolean,
    data: ICluster | null,
    clusterStatusId: number,
    rccapSwaps: ICluster[],
    onClose: () => void,
    onCloseAndReload: (actionType: number, emailStatusType: EmailStatusType) => void,
    onCommenceMatchOffer: () => void,
    commenceMatchOfferImmediately: (swapId: number, clusterId: number, deadline: string, forceTargetSurgeryDate: boolean, positions: number[], clcPositions: number[], matchOfferType: number, sendEmail: boolean) => void,
    cancelMatchOfferImmediately: (swapId: number, type: number, clusterId: number, date: string, realtimeSwapFailure: boolean, useStreamlinedCancellation: boolean, preselectReversal: boolean, prereversalResponsibles: any[]) => void,
    showSidePanel: (actionType: number, drawerEmailParams: any) => void
}

interface IStateProps {
    staffList: IContact[],
    rccapPhaseList: IListItem[],
    rccapAvoidableList: IListItem[],
    rccapBillableList: IListItem[],
    rccapCauseList: IRccapRootCause[],
    rccapCorrectiveActionList: IListItem[],
    rccapSatisfactoryResponseList: IListItem[]
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    showAlert: (title: string, message: string | JSX.Element) => void,
    getRccapDetails: (chainId: number, clusterNumber: number, positionNumber: number) => Promise<IRccapPositionDetailResponse>,
    saveRccapDetails: (details: IRccapPositionDetailRequest) => Promise<IBaseResponse>,
    getMatchingCalls: (dateValue: string) => Promise<IMatchingCallsResponse>,
    commenceMatchOffer: (clusterId: number, deadline: string, forceTargetSurgeryDate: boolean, positions: number[], clcPositions: number[], matchOfferType: number, sendEmail: boolean) => Promise<IBaseResponse>,
    commenceSwap: (clusterId: number, usageContract: IStrongBoxUsageContract) => Promise<IBaseResponse>,
    sendImmediateEmail: (type: number, clusterId: number, date: string, realtimeSwapFailure: boolean, useStreamlinedCancellation: boolean, preselectReversal: boolean, prereversalResponsibles: any[], sendEmail: boolean) => Promise<IBaseResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    actionType: number,
    forceTargetSurgeyDates: boolean,
    dateTime: string,
    labelFormat: string,
    cancelSwap: ICancelSwap,
    streamlinedCancellation: boolean,
    positions: IActionPosition[],
    rccapPositions: IActionPosition[],
    rccapResponseCenterSelected: boolean,
    matchingCalls: string[],
    matchOfferDeadlineError: boolean,
    callDateError: boolean,
    pickUpDate: string,
    centers: IResponsibleCenter[],
    realTimeSwapFailure: boolean,
    preselectReversal: boolean,
    showEmailSidePanel: boolean
}

const initialState: IState = {
    actionType: -1,
    forceTargetSurgeyDates: true,
    dateTime: moment().format("MM/DD/YY HH:mm"),
    labelFormat: "5164",
    cancelSwap: {
        chainId: "",
        clusterNumber: "",
        positionNumber: "",

        donorId: 0,
        donorCenterId: 0,
        donorCenterAlias: "",
        remoteDonorCenterId: 0,
        remoteDonorCenterAlias: "",
        donorAlias: "",

        recipientId: 0,
        recipientAlias: "",
        recipientAbo: "",
        pairedDonorAbo: "",
        recipientPmpC: "",
        recipientCpra: "",
        recipientCenterId: 0,
        recipientCenterAlias: "",

        responsibleCenter: 0,
        requester: 0,
        failDate: "",
        nkrLiaison: 0,
        dueDate: "",

        transplantsImpacted: 0,

        matchOfferDate: "",

        exmRequestedDate: "",
        rccapPhase: 0,

        issueDescription: "",
        issueDescriptionValid: true,
        additionalQuestions: [],
        rootCausePrimary: 0,
        rootCauseSecondary: 0,
        rccapAvoidable: 0,
        rccapBillable: 0,
        rccapSatisfactoryResponse: 0,
        acceptedResponse: "",
        correctiveActionPrimary: 0,
        correctiveActionSecondary: 0,
        centerCorrectiveAction: "",
        responder: "",
        responseDate: "",
        dataRetrieved: false
    },
    streamlinedCancellation: false,
    positions: [],
    rccapPositions: [],
    rccapResponseCenterSelected: false,
    matchingCalls: [],
    matchOfferDeadlineError: false,
    callDateError: false,
    pickUpDate: '',
    centers: [],
    realTimeSwapFailure: false,
    showEmailSidePanel: false,
    preselectReversal: false
};

class Actions extends React.Component<TProps, IState> {
    readonly state: IState = initialState;

    componentDidMount() {
        this.checkPreselectReversal(this.props);
    }

    componentDidUpdate(prevProps: TProps) {
        let hasSomeResponsible = this.state.positions?.some(x => x.position.reversalResponsible != PreSelectReversalResponsible.NeitherSelected
            && x.position.reversalResponsible != null);

        if ((prevProps.data !== this.props.data) || hasSomeResponsible) {
            this.checkPreselectReversal(this.props);
        }
    }

    checkPreselectReversal = (props: TProps) => {
        let hasPreselectReversals = this.state.positions?.some(x => x.position.hasPreselectReversal);
        if (hasPreselectReversals && !this.state.preselectReversal) {
            this.setState({ preselectReversal: true });
        }
    };

    componentWillReceiveProps = (nextProps: TProps) => {
        if (_.isEqual(this.props, nextProps)) return;

        if (nextProps.data != null) {
            let positions: IActionPosition[] = nextProps.data.positions.map((position) => {
                const dCenter = position.donor.rdnCenter ?? position.donor.center;
                return {
                    position,
                    include: position.recipient.id > 0 ? true : false,
                    includeClc: -1,
                    responsible: "",
                    showInclude: true,
                    useStrongBox: dCenter.isActiveStrongBoxCenter && dCenter.id != position.recipient.centerId

                };
            });

            let centers = _.cloneDeep(this.state.centers)

            positions.forEach(item => {
                var centerId = item.position.donor.center.id;
                var centerAlias = item.position.donor.center.alias;

                var rdnCenterId = item.position.donor.rdnCenterId;
                var rdnCenterAlias = item.position.donor.rdnCenterAlias;

                if (centers.find(c => c.id == centerId) == null) {
                    centers.push({ id: centerId, alias: centerAlias });
                }

                if (rdnCenterId > 0 && centers.find(c => c.id == rdnCenterId) == null) {
                    centers.push({ id: rdnCenterId, alias: rdnCenterAlias });
                }

                centerId = item.position.recipient.center.id;
                centerAlias = item.position.recipient.center.alias;

                if (centers.find(c => c.id == centerId) == null) {
                    centers.push({ id: centerId, alias: centerAlias });
                }
            });

            let rccapPositions: IActionPosition[] = [];

            if (nextProps.data != null) {
                nextProps.rccapSwaps.forEach(cluster => {
                    cluster.positions.forEach(position => {
                        rccapPositions.push({
                            position,
                            include: nextProps.data.clusterNumber == position.clusterNumber,
                            includeClc: -1,
                            responsible: "",
                            showInclude: nextProps.data.clusterNumber == position.clusterNumber
                        });
                    });
                });
            }

            let dateTime = this.getDeadline(this.state.actionType);

            this.setState({
                ...initialState,
                positions,
                rccapPositions,
                dateTime,
                centers
            })
        }
    }

    handleActionTypeChanged = async (actionType: number) => {
        let matchOfferActions = [ActionTypes.MatchOffer, ActionTypes.FastTrackMatchOffer, ActionTypes.SlowTrackMatchOffer];

        let dateTime = this.getDeadline(actionType);
        let positions = _.cloneDeep(this.state.positions);

        let isCancelSwap = actionType == ActionTypes.CancelSwap;
        let isMatchOfferSwap = matchOfferActions.indexOf(actionType) >= 0;
        let isScheduleCall = actionType == ActionTypes.ScheduleLogisticsCalls || actionType == ActionTypes.ScheduleKickOff;
        let allPositionsChecked = this.allPositionsChecked(isCancelSwap, this.props.data.clusterNumber, this.props.data.clusterStatusId);
        let allowStreamlinedCancellation = isCancelSwap && this.props.data.isFinalCluster && allPositionsChecked;

        let forceTargetSurgeyDates = this.state.forceTargetSurgeyDates;

        if (isMatchOfferSwap) {
            let positionCenters = [];

            positions = positions.map(item => {
                item.includeClc = (item.position.recipient.center.clc >= 0 && item.position.isPreAccepted) ? 1 : 0;

                positionCenters.push(item.position.donor.donationCenterId);
                positionCenters.push(item.position.recipient.centerId);

                return item;
            })

            if (this.props.data.clusterNumber == 1 && (this.props.data.donationType == 'LOOP' || this.props.data.isFinalCluster)) {
                let isSingleCenter = _.uniq(positionCenters).length == 1;

                forceTargetSurgeyDates = isSingleCenter ? false : true;
            }
        }

        if (isCancelSwap) {
            positions = positions.map(x => {
                x.include = true;
                return x;
            });

            if (isCancelSwap && this.props.data.isFinalCluster) {
                allowStreamlinedCancellation = true;
            }
        }

        let matchingCalls: string[] = [];

        if (isScheduleCall) {
            let dt = moment(dateTime, 'MM/DD/YY HH:mm');
            var mc = await this.props.getMatchingCalls(dt.format());

            matchingCalls = mc.data.results;
        }

        this.setState({
            actionType,
            forceTargetSurgeyDates,
            dateTime,
            positions,
            streamlinedCancellation: allowStreamlinedCancellation ? true : false,
            matchingCalls,
            matchOfferDeadlineError: false,
            callDateError: false
        });
    }

    handleDateTimeChange = async (e: moment.Moment) => {
        let matchingCalls: string[] = [];

        if (this.state.actionType == ActionTypes.ScheduleLogisticsCalls || this.state.actionType == ActionTypes.ScheduleKickOff) {
            var mc = await this.props.getMatchingCalls(e.format());

            matchingCalls = mc.data.results;
        }

        this.setState({
            dateTime: e.format("MM/DD/YY HH:mm"),
            matchingCalls
        });
    }

    handleLabelFormatChange = (e: React.FormEvent<any>) => {
        this.setState({
            labelFormat: e.currentTarget.value
        })
    }

    handleIncludeChange = (clusterNumber: number, positionNumber: number, include: boolean) => {
        let isCancelSwap = this.state.actionType == ActionTypes.CancelSwap;
        let streamlinedCancellation = true;

        if (isCancelSwap && this.props.data.clusterStatusId > 2) {
            let rccapPositions = _.cloneDeep(this.state.rccapPositions);
            let position = rccapPositions.find(p => p.position.clusterNumber == clusterNumber && p.position.positionNumber == positionNumber);

            position.include = include;

            let allPositionsChecked = rccapPositions.filter(x => x.include).length == rccapPositions.length;
            streamlinedCancellation = (isCancelSwap && allPositionsChecked);

            this.setState({
                rccapPositions,
                streamlinedCancellation
            });
        } else {
            let positions = _.cloneDeep(this.state.positions);
            let position = positions.find(p => p.position.positionNumber == positionNumber);

            position.include = include;

            let allPositionsChecked = positions.filter(x => x.include).length == positions.length;
            streamlinedCancellation = (isCancelSwap && allPositionsChecked);

            this.setState({
                positions,
                streamlinedCancellation
            });
        }
    }

    handleIncludeClcChange = (clusterNumber: number, positionNumber: number, includeClc: number) => {
        var positions = _.cloneDeep(this.state.positions);
        var position = positions.find(p => p.position.positionNumber == positionNumber);

        position.includeClc = includeClc;

        this.setState({
            positions
        });
    }

    handleReversalResponsibleChange = (clusterNumber: number, positionNumber: number, selected: PreSelectReversalResponsible) => {
        const positions = _.cloneDeep(this.state.positions);
        const position = positions.find(p =>
            p.position.clusterNumber == clusterNumber &&
            p.position.positionNumber == positionNumber
        );

        if (!position) return;

        position.position.reversalResponsible =
            position.position.reversalResponsible == selected
                ? PreSelectReversalResponsible.NeitherSelected
                : selected;

        this.setState({ positions }, () => {
            const allNoneSelected = this.state.positions.every(
                p => p.position.reversalResponsible == PreSelectReversalResponsible.NeitherSelected || p.position.reversalResponsible == null
            );
            this.setState({ preselectReversal: !allNoneSelected });
        });
    };

    handleResponsibleChange = (clusterNumber: number, positionNumber: number, responsible: string) => {
        var rccapPositions = this.state.rccapPositions.map((item) => {
            if (item.position.clusterNumber == clusterNumber && item.position.positionNumber == positionNumber)
                item.responsible = responsible;
            else
                item.responsible = "";

            return _.cloneDeep(item);
        });

        this.props.showLoading("Fetching position information, one moment please...").then(() => {
            this.props.getRccapDetails(this.props.data.chainId, clusterNumber, positionNumber).then((response: IRccapPositionDetailResponse) => {
                var { success, results } = response.data;

                let {
                    requester,
                    donorId, donorAlias, donorCenterId, donorCenterAlias, remoteDonorCenterId, remoteDonorCenterAlias, donorCenterLiaison,
                    recipientId, recipientAlias, recipientAbo, recipientPmpC, recipientCpra, recipientDonorAbo: pairedDonorAbo, recipientCenterId, recipientCenterLiaison,
                    transplantsImpacted, matchOfferDate, rccapPhase, matchHistoryRejectionReasonText: issueDescription, additionalQuestions: originalAdditionalQuestions, matchHistoryCorrectiveAction,
                    exmRequestedDate
                } = results;

                var additionalQuestions = originalAdditionalQuestions.map(q => {
                    let question: IRccapAdditionalQuestionWithValidation = {
                        id: q.id,
                        question: q.question,
                        answer: q.answer,
                        isValid: true,
                        isDeleted: false
                    };

                    return question;
                });

                var cancelSwap: ICancelSwap = {
                    ...this.state.cancelSwap,
                    chainId: this.props.data.chainId.toString(),
                    clusterNumber: clusterNumber.toString(),
                    positionNumber: positionNumber.toString(),

                    donorId,
                    donorAlias,
                    donorCenterId,
                    donorCenterAlias,
                    remoteDonorCenterId,
                    remoteDonorCenterAlias,

                    recipientId,
                    recipientAlias,
                    recipientAbo,
                    recipientPmpC: recipientPmpC.toString(),
                    recipientCpra: recipientCpra.toFixed(2),
                    pairedDonorAbo,
                    recipientCenterId,

                    responsibleCenter: responsible == "donorCenter" ? (remoteDonorCenterId ? remoteDonorCenterId : donorCenterId) : recipientCenterId,
                    requester,
                    failDate: moment().format("MM/DD/YY HH:mm"),
                    nkrLiaison: responsible == "donorCenter" ? donorCenterLiaison : recipientCenterLiaison,
                    dueDate: moment().add(1, "d").format("MM/DD/YY 18:00"),

                    transplantsImpacted,

                    matchOfferDate: matchOfferDate != "" ? moment(matchOfferDate).format("MM/DD/YY HH:mm") : moment().format("MM/DD/YY HH:mm"),
                    exmRequestedDate: exmRequestedDate ? moment(exmRequestedDate).format("MM/DD/YY HH:mm") : "",

                    rccapPhase,

                    issueDescription,
                    additionalQuestions,
                    rootCausePrimary: 0,
                    rootCauseSecondary: 0,
                    rccapAvoidable: 0,
                    rccapBillable: 0,
                    rccapSatisfactoryResponse: 0,
                    acceptedResponse: "",
                    correctiveActionPrimary: 0,
                    correctiveActionSecondary: 0,
                    centerCorrectiveAction: matchHistoryCorrectiveAction,
                    responder: '',
                    responseDate: '',
                    dataRetrieved: true
                };

                if (success) {
                    this.setState({
                        rccapPositions,
                        cancelSwap,
                        rccapResponseCenterSelected: true
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    handleUpdateRccapData = (property: string, value: string) => {
        this.setState({
            cancelSwap: { ...this.state.cancelSwap, [property]: value }
        });
    }

    handleChangeQuestion = (question: string, index: number) => {
        let additionalQuestions = [...this.state.cancelSwap.additionalQuestions];
        additionalQuestions[index] = { ...additionalQuestions[index], question, isValid: true, isDeleted: false };

        this.setState({
            cancelSwap: { ...this.state.cancelSwap, additionalQuestions }
        });
    }

    handleRemoveQuestion = (index: number) => {
        let additionalQuestions = this.state.cancelSwap.additionalQuestions.map((q, itemIndex) => {
            if (index == itemIndex)
                q.isDeleted = true;

            return q;
        });

        this.setState({
            cancelSwap: { ...this.state.cancelSwap, additionalQuestions }
        });
    }

    handleAddQuestion = () => {
        let additionalQuestions = [...this.state.cancelSwap.additionalQuestions];
        additionalQuestions.push({ id: -1, question: '', answer: '', isValid: true, isDeleted: false });

        this.setState({
            cancelSwap: { ...this.state.cancelSwap, additionalQuestions }
        });
    }

    handleIncludeAll = (clusterNumber: number) => {
        if (this.state.actionType != ActionTypes.CancelSwap) {
            let positions = this.state.positions.map(position => {
                position.include = !position.include;
                return _.cloneDeep(position);
            });

            this.setState({
                positions
            });
        } else {
            let rccapPositions = this.state.rccapPositions.map(item => {
                if (item.position.clusterNumber == clusterNumber)
                    item.include = !item.include;

                return _.cloneDeep(item);
            });

            this.setState({
                rccapPositions
            });
        }
    }

    handleClcColumnClick = () => {
        var positions = this.state.positions.map(position => {
            position.includeClc = 0;
            return _.cloneDeep(position);
        });

        this.setState({
            positions
        });
    }

    handleStreamlinedCancellation = (e: React.FormEvent<any>) => {
        this.setState({
            streamlinedCancellation: e.currentTarget.value == "Yes"
        });
    }

    handleRealTimeSwapFailure = (e: React.FormEvent<any>) => {
        this.setState({
            realTimeSwapFailure: e.currentTarget.value == "Yes"
        });
    }

    handlePreselectReversals = (e: React.FormEvent<any>) => {
        const isYes = e.currentTarget.value == "Yes";

        const positions = _.cloneDeep(this.state.positions);

        positions.filter(x => x.position.reversalResponsible != null).map(pos => {
            pos.position.reversalResponsible = isYes
                ? PreSelectReversalResponsible.RecipientCenter
                : PreSelectReversalResponsible.NeitherSelected;
        });

        this.setState({
            preselectReversal: isYes,
            positions
        });
    };

    handleUseStrongBoxChange = (clusterNumber: number, positionNumber: number, useStrongBox: boolean) => {

        let positions = _.cloneDeep(this.state.positions);
        let position = positions.find(p => p.position.positionNumber == positionNumber);

        position.useStrongBox = useStrongBox;

        this.setState({
            positions
        });

    }


    handleCancel = () => {
        this.props.onClose();
    }

    handleRccapWithEmail = () => {
        this.saveRccap(RccapStatus.PendingResponse, false);
    }

    handleRccapWithEmailNew = () => {
        this.saveRccap(RccapStatus.PendingResponse, true);
    }

    handleRccapWithoutEmail = () => {
        this.saveRccap(RccapStatus.Accepted, false);
    }

    handleRccapWithoutEmailNew = () => {
        this.saveRccap(RccapStatus.Accepted, true);
    }

    saveRccap = (status: RccapStatus, newPage: boolean) => {
        if (this.state.cancelSwap.issueDescription == '') {
            let cancelSwap = _.cloneDeep(this.state.cancelSwap);
            cancelSwap.issueDescriptionValid = false;

            this.setState({
                cancelSwap
            }, () => {
                document.getElementsByClassName('modal')[0].scrollTop = 0
            });
        } else {
            let {
                chainId, clusterNumber, positionNumber,
                pairedDonorAbo: recipientDonorAbo,
                recipientPmpC,
                recipientCpra,
                nkrLiaison: rccapManager,
                rccapAvoidable: avoidable,
                rccapBillable: billable,
                rccapSatisfactoryResponse: satisfactoryResponse, donorCenterAlias, recipientCenterAlias, dataRetrieved,
                additionalQuestions,
                ...cancelSwap
            } = this.state.cancelSwap;

            var details: IRccapPositionDetailRequest = {
                ...cancelSwap,
                chainId: parseInt(chainId),
                clusterNumber: parseInt(clusterNumber),
                positionNumber: parseInt(positionNumber),
                recipientPmpC: parseInt(recipientPmpC),
                recipientCpra: parseFloat(recipientCpra),
                recipientDonorAbo,
                rccapManager,
                targetSurgeryDate: "",
                additionalComments: "",
                avoidable,
                billable,
                satisfactoryResponse,
                currentStatus: status,
                additionalQuestions: additionalQuestions.map(q => q.question),
                responder: '',
                responseDate: '',
                wasSwapCancelled: true
            };

            this.props.showLoading("Saving RCCAP details, one moment please...").then(() => {
                this.props.saveRccapDetails(details)
                    .then(response => {
                        if (response.data.success) {
                            toast.success("Successfully saved RCCAP details, redirecting to email page...", {
                                autoClose: 500,
                                onClose: () => {

                                    if (newPage) {
                                        this.gotoEmailPageNew(false);
                                    } else {
                                        this.gotoEmailPage();
                                    }
                                }
                            });
                        } else {
                            toast.error("Unable to save RCCAP details");
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }
    }

    gotoEmailPage = () => {
        var clusterId = this.props.data.id;
        var emailType = actionTypeList.find(at => at.value == this.state.actionType && !at.hideOption);
        var isMatchOffer = this.state.actionType == ActionTypes.MatchOffer || this.state.actionType == ActionTypes.FastTrackMatchOffer || this.state.actionType == ActionTypes.SlowTrackMatchOffer;
        let isCancelSwap = this.state.actionType == ActionTypes.CancelSwap;
        var isCall = this.state.actionType == ActionTypes.ScheduleKickOff || this.state.actionType == ActionTypes.ScheduleLogisticsCalls;

        if (isMatchOffer || this.state.actionType == ActionTypes.CommenceXm) {
            let noErrors = this.checkMatchOfferDate();
            if (!noErrors) {
                return;
            }
        }

        if (isCall) {
            let noCallErrors = this.checkCallDate();
            if (!noCallErrors) {
                return;
            }
        }

        var selectedPositions = this.state.positions.filter(p => p.include == true).map(p => p.position.positionNumber);
        var selectedRccapPositions = this.state.rccapPositions.filter(p => p.include == true).map(p => p.position.positionNumber);
        var selectedClcPositions = this.state.positions.filter(p => p.includeClc == 1).map(p => p.position.positionNumber);
        var selectedRccapClcPositions = this.state.rccapPositions.filter(p => p.includeClc == 1).map(p => p.position.positionNumber);
        let positions = isCancelSwap && this.props.data.clusterStatusId > 2 ? selectedRccapPositions : selectedPositions;
        let clcPositions = isCancelSwap && this.props.data.clusterStatusId > 2 ? selectedRccapClcPositions : selectedClcPositions;
        var hasDeadline = emailType.hasDeadline;

        var dateVar = hasDeadline ? 'deadline' : 'date';
        var dateValue = this.state.dateTime;

        var data = { ClusterId: clusterId, Deadline: dateValue, Positions: positions, Clc: clcPositions };

        var deadline = emailType.needsDate ? '&' + dateVar + '=' + encodeURIComponent(dateValue) : null;
        var extra = (isMatchOffer && this.state.forceTargetSurgeyDates ? '&force=Y' : '&force=N') + (emailType.code == 'FAST-TRACK-MATCH-OFFER' || emailType.code == 'SLOW-TRACK-MATCH-OFFER' ? '&type=' + (emailType.code == 'FAST-TRACK-MATCH-OFFER' ? 'fast' : 'slow') : '');
        let matchOfferType = null;

        if (emailType.code == 'FAST-TRACK-MATCH-OFFER') {
            matchOfferType = 1;
        }

        if (emailType.code == 'SLOW-TRACK-MATCH-OFFER') {
            matchOfferType = 2;
        }

        var postConfig: AxiosRequestConfig = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            withCredentials: true
        };

        var url = __OUTSIDEURL__ + '/WebServices/AdminService.php';

        if (emailType.service != null) {
            // call service then redirect to email

            var d = qs.stringify({ method: emailType.service, params: data });

            this.props.showLoading("One moment please...").then(() => {
                return axios.post(url, d, postConfig)
                    .then((response: IServiceResponse) => {
                        this.props.hideLoading();

                        if (response.data.IsSuccess) {
                            window.location.href =
                                __OUTSIDEURL__ + '/admin/email_centers.php?mode=' + emailType.mode
                                + '&id=' + this.props.data.id
                                + (deadline || '')
                                + '&positions=' + encodeURIComponent(positions.join(','))
                                + extra;
                        } else {
                            this.props.showAlert(
                                "Alert!",
                                <div>
                                    <div style={{ marginBottom: 20 }}>A processing error occurred:</div>
                                    <div style={{ marginLeft: 20 }}>{response.data.ErrorMessages}</div>
                                </div>);
                        }
                    }).catch((error: AxiosError) => {
                        this.props.hideLoading();
                        this.props.showAlert("Fatal", error.message);
                    });
            });
        } else if (isMatchOffer) {
            this.props.showLoading('Sending match offer, one moment please...').then(() => {
                this.props.commenceMatchOffer(clusterId, this.state.dateTime, this.state.forceTargetSurgeyDates, positions, clcPositions, matchOfferType, true)
                    .then(response => {
                        if (response.data.success) {
                            this.props.onCommenceMatchOffer();
                        }
                    })
                    .catch((error: AxiosError) => {
                        toast.error(<>Unable to send match offer(s)<br />Please send the following to the DEV team:<br />{error.response.data}</>, { autoClose: false, draggable: false, closeOnClick: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        } else if (this.state.actionType == ActionTypes.PrintLabels) {
            var labelUrl = __OUTSIDEURL__ + '/admin/print/labels.php?cluster=' + clusterId + '&type=' + this.state.labelFormat;
            var width = 800;
            var height = 550;

            window.open(labelUrl, "Page_PopupWindow", "toolbar=yes,location=yes,status=yes,scrollbars=yes,resizable=yes,width=" + width + ",height=" + height);
        } else if (this.state.actionType == ActionTypes.SwapStart) {
            // this.props.showLoading('Sending swap commencement, one moment please...').then(() => {
            //     this.props.commenceSwap(clusterId)
            //         .then(response => {
            //             if (response.data.success) {
            //                 toast.info('Swap commencement sent', {
            //                     autoClose: 500,
            //                     onClose: () => {
            //                         this.props.onCloseAndReload();
            //                     }
            //                 });
            //             }
            //         })
            //         .finally(() => {
            //             this.props.hideLoading();
            //         });
            // });

            // send swap commencement

            var d = qs.stringify({ method: 'SendSwapCommencement', params: clusterId });

            this.props.showLoading("One moment please...").then(() => {
                axios.post(url, d, postConfig)
                    .then((response: IServiceResponse) => {
                        if (response.data.IsSuccess) {
                            toast.info('Swap commencement sent', {
                                autoClose: 500,
                                onClose: () => {
                                    this.props.onCloseAndReload(this.state.actionType, EmailStatusType.Sent);
                                }
                            });
                        } else {
                            this.props.showAlert(
                                "Alert!",
                                <div>
                                    <div style={{ marginBottom: 20 }}>A processing error occurred:</div>
                                    <div style={{ marginLeft: 20 }}>{response.data.ErrorMessages}</div>
                                </div>);
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        } else if (this.state.actionType == ActionTypes.DonorNotViable) {
            // send donor not viable

            var d = qs.stringify({ method: 'SendDonorNotViable', params: clusterId });

            this.props.showLoading("One moment please...").then(() => {
                axios.post(url, d, postConfig)
                    .then((response: IServiceResponse) => {
                        if (response.data.IsSuccess) {
                            toast.info('Donor Not Viable sent', {
                                onClose: () => {
                                    this.props.onCloseAndReload(this.state.actionType, EmailStatusType.Sent);
                                }
                            });
                        } else {
                            this.props.showAlert(
                                "Alert!",
                                <div>
                                    <div style={{ marginBottom: 20 }}>A processing error occurred:</div>
                                    <div style={{ marginLeft: 20 }}>{response.data.ErrorMessages}</div>
                                </div>);
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        } else {
            // redirect to email

            window.location.href =
                __OUTSIDEURL__ + '/admin/email_centers.php?mode=' + emailType.mode
                + '&id=' + this.props.data.id
                + (deadline || '')
                + '&positions=' + encodeURIComponent(positions.join(','))
                + '&useStreamlinedCancellation=' + (this.state.actionType == ActionTypes.CancelSwap && this.state.streamlinedCancellation ? 1 : 0)
                + '&realtimeSwapFailure=' + (this.state.actionType == ActionTypes.CancelSwap && this.state.realTimeSwapFailure ? 1 : 0)
                + extra;
        }
    }

    gotoEmailPageNew = (sendImmediately: boolean) => {
        let clusterId = this.props.data.id;
        let emailType = actionTypeList.find(at => at.value == this.state.actionType && !at.hideOption);
        let isMatchOffer = this.state.actionType == ActionTypes.MatchOffer || this.state.actionType == ActionTypes.FastTrackMatchOffer || this.state.actionType == ActionTypes.SlowTrackMatchOffer;
        let isCancelSwap = this.state.actionType == ActionTypes.CancelSwap;
        let isCall = this.state.actionType == ActionTypes.ScheduleKickOff || this.state.actionType == ActionTypes.ScheduleLogisticsCalls;
        let isCommenceXm = this.state.actionType == ActionTypes.CommenceXm;
        let isImmediateSendType = isCommenceXm || isCall || isCancelSwap;

        if (isMatchOffer || this.state.actionType == ActionTypes.CommenceXm) {
            let noErrors = this.checkMatchOfferDate();
            if (!noErrors) {
                return;
            }
        }

        if (isCall) {
            let noCallErrors = this.checkCallDate();
            if (!noCallErrors) {
                return;
            }
        }

        let selectedPositions = this.state.positions.filter(p => p.include == true).map(p => p.position.positionNumber);
        let selectedRccapPositions = this.state.rccapPositions.filter(p => p.include == true).map(p => p.position.positionNumber);
        let selectedClcPositions = this.state.positions.filter(p => p.includeClc == 1).map(p => p.position.positionNumber);
        let selectedRccapClcPositions = this.state.rccapPositions.filter(p => p.includeClc == 1).map(p => p.position.positionNumber);
        let positions = isCancelSwap && this.props.data.clusterStatusId > 2 ? selectedRccapPositions : selectedPositions;
        let clcPositions = isCancelSwap && this.props.data.clusterStatusId > 2 ? selectedRccapClcPositions : selectedClcPositions;
        let hasDeadline = emailType.hasDeadline;

        let dateVar = hasDeadline ? 'deadline' : 'date';
        let dateValue = this.state.dateTime;

        let data = { ClusterId: clusterId, Deadline: dateValue, Positions: positions, Clc: clcPositions };

        let deadline = emailType.needsDate ? dateValue : null;
        let extra = (isMatchOffer && this.state.forceTargetSurgeyDates ? '&force=Y' : '&force=N') + (emailType.code == 'FAST-TRACK-MATCH-OFFER' || emailType.code == 'SLOW-TRACK-MATCH-OFFER' ? '&type=' + (emailType.code == 'FAST-TRACK-MATCH-OFFER' ? 'fast' : 'slow') : '');
        let matchOfferType = null;

        if (emailType.code == 'FAST-TRACK-MATCH-OFFER') {
            matchOfferType = 1;
        }

        if (emailType.code == 'SLOW-TRACK-MATCH-OFFER') {
            matchOfferType = 2;
        }

        let postConfig: AxiosRequestConfig = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            withCredentials: true
        };

        let url = __OUTSIDEURL__ + '/WebServices/AdminService.php';

        if (isMatchOffer && sendImmediately == false) {
            this.props.showLoading('Generating Match Offer email template, one moment please...').then(() => {
                let drawerEmailParams: {
                    mode: string;
                    id: string;
                    deadline: string;
                    dateTime: string;
                    forceTargetSurgeyDates: boolean;
                    matchOfferType: number,
                    positions: string;
                    extra: string;

                } = {
                    mode: emailType.mode,
                    id: this.props.data.id.toString(),
                    deadline,
                    dateTime: dateValue,
                    forceTargetSurgeyDates: this.state.forceTargetSurgeyDates,
                    matchOfferType,
                    positions: positions.join(','),
                    extra
                };

                this.props.hideLoading();
                this.props.onClose();
                this.props.showSidePanel(ActionTypes.MatchOffer, drawerEmailParams);
            });
        } else if (emailType.service != null && sendImmediately == false) {
            // call service then redirect to email
            let deadlineEncoded = emailType.needsDate ? '&' + dateVar + '=' + encodeURIComponent(dateValue) : null;
            // let d = qs.stringify({ method: emailType.service, params: data });

            // this.props.showLoading("One moment please...").then(() => {
            //     return axios.post(url, d, postConfig)
            //         .then((response: IServiceResponse) => {
            //             if (response.data.IsSuccess) {
            //                 window.location.href = '/admin/email'
            //                     + '?mode=' + emailType.mode
            //                     + '&id=' + this.props.data.id
            //                     + (deadlineEncoded || '')
            //                     + '&positions=' + encodeURIComponent(positions.join(','))
            //                     + extra;
            //             } else {
            //                 this.props.showAlert(
            //                     "Alert!",
            //                     <div>
            //                         <div style={{ marginBottom: 20 }}>A processing error occurred:</div>
            //                         <div style={{ marginLeft: 20 }}>{response.data.ErrorMessages}</div>
            //                     </div>);
            //             }
            //         }).catch((error: AxiosError) => {
            //             this.props.showAlert("Fatal", error.message);
            //         })
            //         .finally(() => {
            //             this.props.hideLoading();
            //         });
            // });

            let immediateType = ImmediteEmailType.ScheduleLogistics;

            if (this.state.actionType == ActionTypes.ScheduleKickOff) {
                immediateType = ImmediteEmailType.ScheduleKickoff;
            } else if (this.state.actionType == ActionTypes.CommenceXm) {
                immediateType = ImmediteEmailType.CommenceXm;
            } else if (this.state.actionType == ActionTypes.CancelSwap) {
                immediateType = ImmediteEmailType.CancelSwap;
            }

            this.props.showLoading('Updating, one moment please...').then(() => {
                var allpositions = _.cloneDeep(this.state.positions);

                var prereversalResponsibleRecords = allpositions
                    .filter(p => p.position.clusterId == clusterId && p.position.hasPreselectReversal)
                    .map(p => ({
                        clusterId: p.position.clusterId,
                        positionNumber: p.position.positionNumber,
                        reversalResponsible: p.position.reversalResponsible
                    }));

                this.props.sendImmediateEmail(immediateType, clusterId, dateValue, this.state.realTimeSwapFailure, this.state.streamlinedCancellation, this.state.preselectReversal, prereversalResponsibleRecords, false)
                    .then(response => {
                        if (response.data.success) {
                            window.location.href = '/admin/email'
                                + '?mode=' + emailType.mode
                                + '&id=' + this.props.data.id
                                + (deadlineEncoded || '')
                                + '&positions=' + encodeURIComponent(positions.join(','))
                                + extra;
                        }
                    })
                    .catch((error: any) => {
                        toast.error(<>Unable to process request<br />Please send the following to the DEV team:<br />{error.response.data}</>, { autoClose: false, draggable: false, closeOnClick: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        } else if (isMatchOffer && sendImmediately == true) {
            this.props.onClose();
            this.props.commenceMatchOfferImmediately(this.props.data.id, clusterId, this.state.dateTime, this.state.forceTargetSurgeyDates, positions, clcPositions, matchOfferType, true);
        } else if (isImmediateSendType && sendImmediately == true) {
            let { actionType } = this.state;

            let msg = 'Schedule logistics call email sent';
            let immediateType = ImmediteEmailType.ScheduleLogistics;

            if (actionType == ActionTypes.ScheduleKickOff) {
                immediateType = ImmediteEmailType.ScheduleKickoff;
                msg = 'Schedule kick off call email sent'
            } else if (actionType == ActionTypes.CommenceXm) {
                immediateType = ImmediteEmailType.CommenceXm;
                msg = 'Commence VXM & DRR email sent';
            } else if (actionType == ActionTypes.CancelSwap) {
                immediateType = ImmediteEmailType.CancelSwap;
                msg = 'Cancel swap email sent';
            }

            if (actionType == ActionTypes.CancelSwap) {
                var allpositions = _.cloneDeep(this.state.positions);

                var prereversalResponsibleRecords = allpositions
                    .filter(p => p.position.clusterId == clusterId && p.position.hasPreselectReversal)
                    .map(p => ({
                        clusterId: p.position.clusterId,
                        positionNumber: p.position.positionNumber,
                        reversalResponsible: p.position.reversalResponsible
                    }));

                this.props.onClose();
                this.props.cancelMatchOfferImmediately(this.props.data.id, immediateType, clusterId, dateValue, this.state.realTimeSwapFailure, this.state.streamlinedCancellation, this.state.preselectReversal, prereversalResponsibleRecords);
            }
            else {
                this.props.showLoading('Updating and sending email, one moment please...').then(() => {
                    var allpositions = _.cloneDeep(this.state.positions);

                    var prereversalResponsibleRecords = allpositions
                        .filter(p => p.position.clusterId == clusterId && p.position.hasPreselectReversal)
                        .map(p => ({
                            clusterId: p.position.clusterId,
                            positionNumber: p.position.positionNumber,
                            reversalResponsible: p.position.reversalResponsible
                        }));

                    this.props.sendImmediateEmail(immediateType, clusterId, dateValue, this.state.realTimeSwapFailure, this.state.streamlinedCancellation, this.state.preselectReversal, prereversalResponsibleRecords, true)
                        .then(response => {
                            if (response.data.success) {
                                toast.info(msg, {
                                    autoClose: 500,
                                    onClose: () => {
                                        this.props.onCloseAndReload(this.state.actionType, EmailStatusType.Sent);
                                    }
                                });
                            }
                        })
                        .catch((error: any) => {
                            toast.error(<>Unable to process request<br />Please send the following to the DEV team:<br />{error.response.data}</>, { autoClose: false, draggable: false, closeOnClick: false });
                        })
                        .finally(() => {
                            this.props.hideLoading();
                        });
                })
            }

        } else if (this.state.actionType == ActionTypes.PrintLabels) {
            let labelUrl = __OUTSIDEURL__ + '/admin/print/labels.php?cluster=' + clusterId + '&type=' + this.state.labelFormat;
            let width = 800;
            let height = 550;

            window.open(labelUrl, "Page_PopupWindow", "toolbar=yes,location=yes,status=yes,scrollbars=yes,resizable=yes,width=" + width + ",height=" + height);
        } else if (this.state.actionType == ActionTypes.SwapStart) {
            const strongBoxPositions = this.state.positions.reduce((acc, pos) => {
                if (pos.useStrongBox) {
                    acc.push(pos.position.positionNumber);
                }

                return acc;
            }, []);

            this.props.showLoading('Sending swap commencement, one moment please...').then(() => {
                this.props.commenceSwap(clusterId, { clusterId: clusterId, swapPositions: strongBoxPositions })
                    .then(response => {
                        if (response.data.success) {
                            toast.info('Swap commencement sent', {
                                autoClose: 500,
                                onClose: () => {
                                    this.props.onCloseAndReload(this.state.actionType, EmailStatusType.Sent);
                                }
                            });
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        } else if (this.state.actionType == ActionTypes.DonorNotViable) {
            // send donor not viable

            let d = qs.stringify({ method: 'SendDonorNotViable', params: clusterId });

            this.props.showLoading("One moment please...").then(() => {
                axios.post(url, d, postConfig)
                    .then((response: IServiceResponse) => {
                        if (response.data.IsSuccess) {
                            toast.info('Donor Not Viable sent', {
                                autoClose: 500,
                                onClose: () => {
                                    this.props.onCloseAndReload(this.state.actionType, EmailStatusType.Sent);
                                }
                            });
                        } else {
                            this.props.showAlert(
                                "Alert!",
                                <div>
                                    <div style={{ marginBottom: 20 }}>A processing error occurred:</div>
                                    <div style={{ marginLeft: 20 }}>{response.data.ErrorMessages}</div>
                                </div>);
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        } else {
            let p = qs.parse(location.search, { ignoreQueryPrefix: true });
            let swapStatus = p.status ? Number(p.status) : null;
            let isCancelSwap = this.state.actionType == ActionTypes.CancelSwap;
            let isNewValidCancelStatus = swapStatus == 2;

            // redirect to email 
            var clonedPositions = _.cloneDeep(this.state.positions);

            var prereversalResponsibleRecords = clonedPositions
                .filter(p => p.position.clusterId == clusterId && p.position.hasPreselectReversal)
                .map(p => ({
                    clusterId: p.position.clusterId,
                    positionNumber: p.position.positionNumber,
                    reversalResponsible: p.position.reversalResponsible
                }));

            if (!isCancelSwap || !isNewValidCancelStatus) {
                window.location.href = '/admin/email'
                    + '?mode=' + emailType.mode
                    + '&id=' + this.props.data.id
                    + (deadline || '')
                    + '&positions=' + encodeURIComponent(positions.join(','))
                    + '&useStreamlinedCancellation=' + (this.state.actionType == ActionTypes.CancelSwap && this.state.streamlinedCancellation ? 1 : 0)
                    + '&realTimeSwapFailure=' + (this.state.actionType == ActionTypes.CancelSwap && this.state.realTimeSwapFailure ? 1 : 0)
                    + '&preselectReversal=' + (this.state.actionType == ActionTypes.CancelSwap && this.state.preselectReversal ? 1 : 0)
                    + '&prereversalResponsibles=' + encodeURIComponent(JSON.stringify(prereversalResponsibleRecords))
                    + extra;
            }

            else {
                this.props.showLoading('Generating Cancel Swap email template, one moment please...').then(() => {
                    let drawerEmailParams: {
                        mode: string;
                        id: string;
                        deadline: string;
                        dateTime: string;
                        forceTargetSurgeyDates: boolean;
                        matchOfferType: number,
                        positions: string;
                        useStreamlinedCancellation: number;
                        realTimeSwapFailure: number;
                        preselectReversal: number;
                        prereversalResponsibles: string;
                        extra: string;
                    } = {
                        mode: emailType.mode,
                        id: this.props.data.id.toString(),
                        deadline,
                        dateTime: dateValue,
                        forceTargetSurgeyDates: this.state.forceTargetSurgeyDates,
                        matchOfferType,
                        positions: positions.join(','),
                        useStreamlinedCancellation: (this.state.actionType == ActionTypes.CancelSwap && this.state.streamlinedCancellation ? 1 : 0),
                        realTimeSwapFailure: (this.state.actionType == ActionTypes.CancelSwap && this.state.realTimeSwapFailure ? 1 : 0),
                        preselectReversal: (this.state.actionType == ActionTypes.CancelSwap && this.state.preselectReversal ? 1 : 0),
                        prereversalResponsibles: encodeURIComponent(JSON.stringify(prereversalResponsibleRecords)),
                        extra
                    };

                    this.props.hideLoading();
                    this.props.onClose();
                    this.props.showSidePanel(ActionTypes.CancelSwap, drawerEmailParams);
                });
            }
        }
    }

    getDeadline = (actionType: number): string => {
        let dateTime = this.state.dateTime;
        let hours = actionType == ActionTypes.CommenceXm ? 16 : 15;

        switch (actionType) {
            case ActionTypes.CommenceXm:
                const daysToAddArray = [4, 3, 3, 3, 3, 3, 4];
                let daysToAdd = daysToAddArray[new Date().getDay()];

                var lateDateTime = moment(moment().date + ' ' + '18:00');
                var isLateOrder = moment().isSameOrAfter(lateDateTime);

                //added logic to handle late orders
                //Sundays and Saturdays are excluded (Not business days)
                if (isLateOrder
                    && moment().day() != 0
                    && moment().day() != 6) {
                    daysToAdd = daysToAdd + 1;
                }

                dateTime = moment().addBusinessDays(daysToAdd).hour(hours).minute(0).format("MM/DD/YY HH:mm");
                break;

            default:
                let day = new Date().getDay();
                let date = moment();

                if (day != 0 && day != 6 && new Date().getHours() < 12) {
                    hours = 16;
                } else {
                    if (actionType != ActionTypes.ScheduleLogisticsCalls && actionType != ActionTypes.ScheduleKickOff) {
                        date = moment().addBusinessDays(1);
                    }
                }

                dateTime = date.hour(hours).minute(0).format("MM/DD/YY HH:mm");
        }

        return dateTime;
    }

    allPositionsChecked = (isCancelSwap: boolean, clusterNumber: number, clusterStatusId: number) => {
        if (isCancelSwap && clusterStatusId > ClusterStatus.Offers) {
            let rccapPositionCount = this.state.rccapPositions.filter(x => x.position.clusterNumber == clusterNumber).length;
            return this.state.rccapPositions.filter(x => x.include && x.position.clusterNumber == clusterNumber).length == rccapPositionCount;
        } else {
            return this.state.positions.filter(x => x.include).length == this.state.positions.length
        }
    }

    getIsValid = (vxmNotAllowed: boolean) => {
        if (vxmNotAllowed) {
            return false;
        }

        let isMatchOffer = this.state.actionType == ActionTypes.MatchOffer || this.state.actionType == ActionTypes.FastTrackMatchOffer || this.state.actionType == ActionTypes.SlowTrackMatchOffer;
        let isCommencement = this.state.actionType == ActionTypes.SwapStart;

        if (isMatchOffer) {
            return this.state.positions.filter(x => x.include && x.position.kidneyPickup != "").length == this.state.positions.filter(x => x.include).length;
        }

        if (isCommencement) {
            return this.props.data.positions.length == this.props.data.positions.filter(x => x.isDataComplete).length;
        }

        return true;
    }

    checkMatchOfferDate = () => {
        let { dateTime } = this.state;
        let now = moment().utc();
        let month = now.clone().add(1, 'months');
        let date = moment(dateTime).clone();

        if (date.isSameOrBefore(now) || date.isAfter(month)) {
            this.handleShowMatchOfferDateError(true);
            return false;
        } else {
            this.handleShowMatchOfferDateError(false);
            return true;
        }
    }

    checkCallDate = () => {
        let { dateTime, positions, actionType } = this.state;
        let now = moment();
        let date = moment(dateTime).clone();

        let kidneyPickUpString = '';
        let kidneyPickUp = moment(positions[0].position.kidneyPickup).clone();

        if (kidneyPickUp.isValid()) {
            kidneyPickUpString = `: "${kidneyPickUp.format('MM/DD/YYYY HH:mm').toString()}"`
        }

        if (!date.isBefore(kidneyPickUp) || !date.isAfter(now)) {
            this.handleShowCallError(true, kidneyPickUpString);
            return false;
        }

        if (actionType == ActionTypes.ScheduleKickOff) {
            let pickUpAdd72Hours = kidneyPickUp.clone().add(-72, 'hours');

            if (!date.isBetween(pickUpAdd72Hours, kidneyPickUp)) {
                this.handleShowCallError(true, kidneyPickUpString);
                return false;
            }
        }

        this.handleShowCallError(false, kidneyPickUpString);
        return true;
    }

    handleShowMatchOfferDateError = (show: boolean) => {
        this.setState({
            matchOfferDeadlineError: show
        })
    }

    handleShowCallError = (callDateError: boolean, pickUpDate: string) => {
        this.setState({
            callDateError,
            pickUpDate
        })
    }

    getActionTypes = () => {
        let filteredActionTypeList = this.props.clusterStatusId != ClusterStatus.Offers && this.props.clusterStatusId != 0 ? actionTypeList.filter(x => x.value != ActionTypes.CommenceXm && !x.hideOption) : actionTypeList.filter(x => !x.hideOption);
        let actionTypes = _.sortBy(filteredActionTypeList, (t: IActionType) => { return t.displayOrder });

        let isOfferTab = this.props.clusterStatusId == ClusterStatus.Offers;
        let acceptedCount = this.props.data != null ? this.props.data.positions.filter(x => x.matchHistory != null ? x.matchHistory.isAccepted : false).length : 0;
        let positionCount = this.props.data != null ? this.props.data.positions.length : 0;

        let highlightCommenceXm = isOfferTab && acceptedCount == positionCount;
        let highlightCancelSwap = isOfferTab && acceptedCount != positionCount;

        return actionTypes.map(actionType => {
            if (actionType.value == ActionTypes.CommenceXm) {
                actionType.highlight = highlightCommenceXm;
            }

            if (actionType.value == ActionTypes.CancelSwap) {
                actionType.highlight = highlightCancelSwap;
            }

            return actionType;
        });
    }

    render = () => {
        const isMatchOffer = this.state.actionType == ActionTypes.MatchOffer || this.state.actionType == ActionTypes.FastTrackMatchOffer || this.state.actionType == ActionTypes.SlowTrackMatchOffer;
        const isCrossMatch = this.state.actionType == ActionTypes.CommenceXm;
        const isScheduleLogisticsCall = this.state.actionType == ActionTypes.ScheduleLogisticsCalls;
        const isScheduleKickoff = this.state.actionType == ActionTypes.ScheduleKickOff;
        const isPrintlabels = this.state.actionType == ActionTypes.PrintLabels;
        const isCancelSwap = this.state.actionType == ActionTypes.CancelSwap;
        const isCommencement = this.state.actionType == ActionTypes.SwapStart;

        let buttonLabel = <span>Add Comments</span>;


        if (isPrintlabels) {
            buttonLabel = <span>Print Labels</span>;
        }

        const canAlsoSendImmediateEmail = [ActionTypes.ScheduleLogisticsCalls, ActionTypes.ScheduleKickOff, ActionTypes.CommenceXm]
        const actionIncludedInImmediateEmail = canAlsoSendImmediateEmail.includes(this.state.actionType);

        const clusterStatusId = this.props.data != null ? this.props.data.clusterStatusId : -1;
        const clusterNumber = this.props.data ? this.props.data.clusterNumber : 0;

        const allPositionsChecked = this.allPositionsChecked(isCancelSwap, clusterNumber, clusterStatusId);
        const allowStreamlinedCancellation = this.state.actionType == ActionTypes.CancelSwap && this.props.data.isFinalCluster && allPositionsChecked;
        const matchOfferDeadlineError = (isMatchOffer || isCrossMatch) && this.state.matchOfferDeadlineError;
        const callError = (isScheduleKickoff || isScheduleLogisticsCall) && this.state.callDateError;
        const pickUpDate = this.state.pickUpDate;

        const actionTypes = this.getActionTypes();

        const currentActionType = actionTypes.find(x => x.value == this.state.actionType);

        const excludedPositions = this.state.positions.filter(x => x.include == false);

        const hasPreselectReversals = this.state.positions.some(x => x.position.hasPreselectReversal);

        const anyExcludedPositions = excludedPositions.length > 0;

        const singleDonorNoRecipient = this.state.positions.length == 1 ? this.state.positions[0].position.recipient == null || this.state.positions[0].position.recipient.id == -1 : false;

        const vxmNotAllowed = singleDonorNoRecipient == true && currentActionType.value == 1;

        const isValid = this.getIsValid(vxmNotAllowed);

        const showStrongBox = isCommencement && this.state.positions.some(p => {
            const dCenter = p.position.donor.rdnCenter ?? p.position.donor.center;
            return dCenter.isActiveStrongBoxCenter && dCenter.id != p.position.recipient.centerId
        })

        return (
            <Modal bsSize="lg" show={this.props.show} onHide={this.handleCancel}>
                <ModalHeader closeButton>
                    <ModalTitle>E-mail Options</ModalTitle>
                </ModalHeader>

                <ModalBodyWrapper>
                    {matchOfferDeadlineError && (
                        <>
                            <Alert bsStyle="danger" style={{ textAlign: 'center' }}>
                                Deadline must be in the future and cannot be greater than one month from now.
                            </Alert>
                        </>
                    )}

                    {callError && (
                        <>
                            <Alert bsStyle="danger" style={{ textAlign: 'center' }}>
                                <div>
                                    {`Call time must be in the future and before Donor Position 1 Pick Up Date/Time${pickUpDate}`}
                                </div>
                                {isScheduleKickoff && (
                                    <div>
                                        Call should also be within 72 hours of Donor Position 1 Pick Up Date/Time.
                                    </div>
                                )}
                            </Alert>
                        </>
                    )}

                    {vxmNotAllowed && (
                        <>
                            <Alert bsStyle="danger" style={{ textAlign: 'center' }}>
                                This Action is only allowed when there is a recipient.
                            </Alert>
                        </>
                    )}

                    <div className="container-fluid">
                        <ActionsRowWrapper className='row'>
                            <Col xs={12} lg={3} componentClass={ControlLabel}>
                                Action Type:
                            </Col>
                            <Col xs={12} lg={9}>
                                <div className="pull-right">
                                    <FormControl
                                        componentClass="select"
                                        style={{ width: "initial", padding: "3px 6px", height: 26 }}
                                        value={this.state.actionType}
                                        onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.handleActionTypeChanged(parseInt(e.currentTarget.value))}
                                    >
                                        {actionTypes.map((actionType, index) =>
                                            <option key={index} value={actionType.value}>{actionType.name}</option>
                                        )}
                                    </FormControl>
                                    {/* <DropdownButton bsStyle='primary' bsSize='sm' title={currentActionType.name} id='swap-actions'>
                                        {actionTypes.map((actionType, index) =>
                                            <MenuItem key={'sa-' + index} eventKey={actionType.value} onClick={() => this.handleActionTypeChanged(actionType.value)}>
                                                <>{actionType.highlight ? <span style={{ backgroundColor: 'yellow', padding: '2px 5px' }}>{actionType.name}</span> : <span style={{ padding: '2px 5px' }}>{actionType.name}</span>}</>
                                            </MenuItem>
                                        )}
                                    </DropdownButton> */}
                                </div>
                            </Col>
                        </ActionsRowWrapper>

                        {isMatchOffer && (
                            <ActionsRowWrapper className='row'>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>
                                    Match Offer Deadline:
                                </Col>
                                <Col xs={12} lg={9}>
                                    <div className="pull-right">
                                        <DateTimePicker
                                            property="dateTime"
                                            currentValue={this.state.dateTime}
                                            onValueChanged={(property, moment) => this.handleDateTimeChange(moment)}
                                        />
                                    </div>
                                </Col>
                            </ActionsRowWrapper>
                        )}

                        {isCrossMatch && (
                            <ActionsRowWrapper className='row'>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>
                                    Cross Match Deadline:
                                </Col>
                                <Col xs={12} lg={9}>
                                    <div className="pull-right">
                                        <DateTimePicker
                                            property="dateTime"
                                            currentValue={this.state.dateTime}
                                            onValueChanged={(property, moment) => this.handleDateTimeChange(moment)}
                                        />
                                    </div>
                                </Col>
                            </ActionsRowWrapper>
                        )}

                        {(isScheduleLogisticsCall || isScheduleKickoff) && (
                            <ActionsRowWrapper className='row'>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>
                                    Call Date/Time:
                                </Col>
                                <Col xs={12} lg={9}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        {this.state.matchingCalls.length > 0 && (
                                            <div style={{ backgroundColor: 'yellow', padding: '3px 5px 3px 5px', marginRight: 5 }}>Date and time already in use for swap(s): {this.state.matchingCalls.join(', ')}</div>
                                        )}

                                        <DateTimePicker
                                            property="dateTime"
                                            currentValue={this.state.dateTime}
                                            onValueChanged={(property, moment) => this.handleDateTimeChange(moment)}
                                        />
                                    </div>
                                </Col>
                            </ActionsRowWrapper>
                        )}

                        {isPrintlabels && (
                            <ActionsRowWrapper className='row'>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>
                                    Label Format:
                                </Col>
                                <Col xs={12} lg={9}>
                                    <div className="pull-right">
                                        <label className="radio-inline">
                                            <input type="radio" name="PrintLabels" value="5164" checked={this.state.labelFormat == "5164"} onChange={this.handleLabelFormatChange} /> 5164 (6 labels)
                                        </label>

                                        <label className="radio-inline">
                                            <input type="radio" name="PrintLabels" value="5168" checked={this.state.labelFormat == "5168"} onChange={this.handleLabelFormatChange} /> 5168 (4 labels)
                                        </label>
                                    </div>
                                </Col>
                            </ActionsRowWrapper>
                        )}

                        {allowStreamlinedCancellation && (
                            <ActionsRowWrapper className='row'>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>
                                    Streamlined Cancellation:
                                </Col>
                                <Col xs={12} lg={9}>
                                    <div className="pull-right">
                                        <label className="radio-inline">
                                            <input type="radio" name="StreamlinedCancellation" value="Yes" checked={this.state.streamlinedCancellation} onChange={this.handleStreamlinedCancellation} /> Yes
                                        </label>

                                        <label className="radio-inline">
                                            <input type="radio" name="StreamlinedCancellation" value="No" checked={!this.state.streamlinedCancellation} onChange={this.handleStreamlinedCancellation} /> No
                                        </label>
                                    </div>
                                </Col>
                            </ActionsRowWrapper>
                        )}

                        {isCancelSwap && (
                            <ActionsRowWrapper className='row'>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>
                                    Is Real-Time Swap Failure:
                                </Col>
                                <Col xs={12} lg={9}>
                                    <div className="pull-right">
                                        <label className="radio-inline">
                                            <input type="radio" name="realtimeSwapFailure" value="Yes" checked={this.state.realTimeSwapFailure} onChange={this.handleRealTimeSwapFailure} /> Yes
                                        </label>

                                        <label className="radio-inline">
                                            <input type="radio" name="realTimeSwapFailure" value="No" checked={!this.state.realTimeSwapFailure} onChange={this.handleRealTimeSwapFailure} /> No
                                        </label>
                                    </div>
                                </Col>
                            </ActionsRowWrapper>
                        )}


                        {isCancelSwap && hasPreselectReversals && (
                            <ActionsRowWrapper className='row'>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>
                                    Is Preselect Reversal:
                                </Col>
                                <Col xs={12} lg={9}>
                                    <div className="pull-right">
                                        <label className="radio-inline">
                                            <input type="radio" name="preselectReversal" value="Yes" checked={this.state.preselectReversal} onChange={this.handlePreselectReversals} /> Yes
                                        </label>

                                        <label className="radio-inline">
                                            <input type="radio" name="preselectReversal" value="No" checked={!this.state.preselectReversal} onChange={this.handlePreselectReversals} /> No
                                        </label>
                                    </div>
                                </Col>
                            </ActionsRowWrapper>
                        )}

                        {isCancelSwap && clusterStatusId > ClusterStatus.Offers ?
                            <>
                                <div style={{ marginTop: 20 }}>
                                    {!this.state.rccapResponseCenterSelected && (
                                        <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                                            Please select the responsible center to start the RCCAP request...
                                        </Alert>
                                    )}

                                    <Row>
                                        <Col xs={12} lg={12}>
                                            <RccapSwapList
                                                clusterNumber={clusterNumber}
                                                positions={this.state.rccapPositions}
                                                onIncludeAll={this.handleIncludeAll}
                                                onIncludeChange={this.handleIncludeChange}
                                                onResponsibleChange={this.handleResponsibleChange}
                                            />
                                        </Col>
                                    </Row>
                                </div>

                                {this.state.rccapResponseCenterSelected && (
                                    <Row>
                                        <Col xs={12} lg={12}>
                                            <RccapDetail
                                                data={this.state.cancelSwap}
                                                centers={this.state.centers}
                                                staffList={this.props.staffList}
                                                rccapPhaseList={this.props.rccapPhaseList}
                                                rccapAvoidableList={this.props.rccapAvoidableList}
                                                rccapBillableList={this.props.rccapBillableList}
                                                rccapCauseList={this.props.rccapCauseList}
                                                rccapCorrectiveActionList={this.props.rccapCorrectiveActionList}
                                                rccapSatisfactoryResponseList={this.props.rccapSatisfactoryResponseList}
                                                updateData={this.handleUpdateRccapData}
                                                onChangeQuestion={this.handleChangeQuestion}
                                                onRemoveQuestion={this.handleRemoveQuestion}
                                                onAddQuestion={this.handleAddQuestion}
                                            />
                                        </Col>
                                    </Row>
                                )}
                            </>
                            :
                            <>
                                {this.state.actionType >= ActionTypes.DefaultEmail && (
                                    <Row>
                                        <Col xs={12} lg={12}>
                                            <SwapList
                                                showStrongBox={showStrongBox}
                                                clusterNumber={clusterNumber}
                                                positions={this.state.positions}
                                                isMatchOffer={isMatchOffer}
                                                isCancelSwap={isCancelSwap}
                                                isCommencement={isCommencement}
                                                hasPreselectReversal={hasPreselectReversals}
                                                onIncludeAll={this.handleIncludeAll}
                                                onClcColumnClick={this.handleClcColumnClick}
                                                onIncludeChange={this.handleIncludeChange}
                                                onIncludeClcChange={this.handleIncludeClcChange}
                                                onReversalResponsibleChange={this.handleReversalResponsibleChange}
                                                onUseStrongBoxChange={this.handleUseStrongBoxChange}
                                            />
                                        </Col>
                                    </Row>
                                )}
                            </>
                        }

                        {isMatchOffer && !isValid && (
                            <div style={{ padding: 7.5 }}>The position(s) in <span style={{ fontWeight: 700, color: "rgb(255, 0, 0)" }}>red</span> do not have surgery dates...</div>
                        )}

                        {isCommencement && !isValid && (
                            <Alert bsStyle='danger' style={{ padding: 7.5 }}>
                                <div className='text-center'>
                                    <div style={{ marginBottom: 5 }}>One or more positions are missing data.  Each position must have the following data prior to commencing a swap:</div>
                                    <div>UNOS ID, job number, donor surgeon, recipient surgeon</div>
                                </div>
                            </Alert>
                        )}
                    </div>
                </ModalBodyWrapper>

                <ModalFooter>
                    {isCancelSwap && clusterStatusId > ClusterStatus.Offers ?
                        <>
                            <Button bsStyle="primary" style={{ height: 60 }} disabled={!isValid || !this.state.rccapResponseCenterSelected} onClick={this.handleRccapWithEmailNew}>
                                <div>
                                    <div>
                                        Send RCCAP E-mail
                                    </div>
                                    <div style={{ backgroundColor: "#f89406", padding: "2px 4px", fontSize: 14, borderRadius: 3 }}>Pending Response</div>
                                </div>
                            </Button>

                            <Button bsStyle="primary" style={{ height: 60 }} disabled={!isValid || !this.state.rccapResponseCenterSelected} onClick={this.handleRccapWithoutEmailNew}>
                                <div>
                                    Don't Send RCCAP E-mail
                                </div>
                                <div style={{ backgroundColor: "#999", padding: "2px 4px", fontSize: 14, borderRadius: 3 }}>Accepted</div>
                            </Button>

                            <Button bsStyle="default" style={{ height: 60 }} onClick={this.handleCancel}>Cancel</Button>
                        </>
                        :
                        <>
                            {(isMatchOffer || (this.props.clusterStatusId == ClusterStatus.Offers && this.state.actionType == ActionTypes.CancelSwap && !singleDonorNoRecipient)) &&
                                <Button bsStyle='primary' onClick={() => this.gotoEmailPageNew(true)}>Send</Button>
                            }

                            {((actionIncludedInImmediateEmail && !anyExcludedPositions) || this.state.actionType == ActionTypes.SwapStart) &&
                                <Button bsStyle='primary' disabled={!(this.state.actionType >= ActionTypes.DefaultEmail && isValid)} onClick={() => this.gotoEmailPageNew(true)}>Send</Button>
                            }

                            {(this.state.actionType != ActionTypes.SwapStart && this.state.actionType != ActionTypes.PleaseSelect) &&
                                <>
                                    <Button bsStyle="info" style={{ backgroundColor: 'lightskyblue', color: '#133666' }} disabled={!(this.state.actionType >= ActionTypes.DefaultEmail && isValid)} onClick={() => this.gotoEmailPageNew(false)}>{buttonLabel}</Button>
                                </>
                            }

                            {(this.state.actionType == ActionTypes.PleaseSelect) &&
                                <>
                                    <Button bsStyle="primary" disabled={(this.state.actionType == ActionTypes.PleaseSelect)} onClick={() => this.gotoEmailPageNew(true)}>Send</Button>
                                </>
                            }

                            <Button bsStyle="default" onClick={this.handleCancel}>Cancel</Button>
                        </>
                    }
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        staffList: state.swaps.staffList,
        rccapPhaseList: state.swaps.rccapPhaseList,
        rccapAvoidableList: state.swaps.rccapAvoidableList,
        rccapBillableList: state.swaps.rccapBillableList,
        rccapCauseList: state.swaps.rccapCauseList,
        rccapCorrectiveActionList: state.swaps.rccapCorrectiveActionList,
        rccapSatisfactoryResponseList: state.swaps.rccapSatisfactoryResponseList
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        showAlert: (title, message) => {
            return dispatch(AppActionCreators.showAlert(title, message));
        },
        getRccapDetails: (chainId, clusterNumber, positionNumber) => {
            return dispatch(SwapActionCreators.getRccapDetails(chainId, clusterNumber, positionNumber));
        },
        saveRccapDetails: (details) => {
            return dispatch(SwapActionCreators.saveRccapDetails(details));
        },
        getMatchingCalls: (dateValue) => {
            return dispatch(SwapActionCreators.getMatchingCalls(dateValue));
        },
        commenceMatchOffer: (clusterId, deadline, forceTargetSurgeryDate, positions, clcPositions, matchOfferType, sendEmail) => {
            return dispatch(SwapActionCreators.commenceMatchOffer(clusterId, deadline, forceTargetSurgeryDate, positions, clcPositions, matchOfferType, sendEmail));
        },
        commenceSwap: (clusterId, strongBoxPositions) => {
            return dispatch(SwapActionCreators.commenceSwap(clusterId, strongBoxPositions));
        },
        sendImmediateEmail: (type, id, date, realtimeSwapFailure, useStreamlinedCancellation, preselectReversal, prereversalResponsibles, sendEmail) => {
            return dispatch(SwapActionCreators.sendImmediateEmail(type, id, date, realtimeSwapFailure, useStreamlinedCancellation, preselectReversal, prereversalResponsibles, sendEmail))
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Actions);